export default "__VITE_ASSET__CibD9uSt__";